var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCaretLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.273 10.566a.722.722 0 0 1 0-1.132l6.134-5.2a1.05 1.05 0 0 1 1.32 0 .722.722 0 0 1 0 1.132L8.253 10l5.474 4.634a.722.722 0 0 1 0 1.132 1.05 1.05 0 0 1-1.32 0z",
  clipRule: "evenodd"
})));
export default SvgCaretLarge;